import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import withRouterCustom from 'utils/hoc/withRouterCustom'
import { withLaunchDarkly } from 'utils/sdks/launchDarkly.v2'
import { withMixpanel } from 'utils/sdks/mixpanel'

import { toggleSelectQuickFilter } from 'store/quickFilters/actions'
import { getSelectedQuickFilters } from 'store/quickFilters/selectors'

import { withAnalytics } from './StatusFilters.analytics'
import StatusFilters from './StatusFilters.component'

const mapStateToProps = (state) => ({
  selectedFilters: getSelectedQuickFilters(state),
})

const mapDispatchToProps = (dispatch) => ({
  toggleSelectQuickFilter: (type, value) =>
    dispatch(toggleSelectQuickFilter(type, value)),
})

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withRedux,
  withMixpanel,
  withRouterCustom,
  withAnalytics,
  withLaunchDarkly,
)(StatusFilters)
